// cSpell:ignore afgehandeld Privaat
// The filters above the settlement list, as the cost list has them (Lewis,
// 2026-10-21): a search, the type, the year and the status. Pure, so
// SettlementsTable only holds the choices.

import {
  TSettlementProgress,
  TSettlementTypeKey,
} from "./settlementListColumns.utils";

// The type filter: every type, or one of the Type column's three.
export enum ESettlementTypeFilter {
  All = "",
  Building = "building",
  Unit = "unit",
  Departure = "departure",
}

// The status filter, worded like the statuses the rows show: still open
// ("0 van 2" or "1 van 2 afgehandeld"), done, or nothing to pay.
export enum ESettlementStatusFilter {
  All = "",
  Open = "open",
  Done = "done",
  Nothing = "nothing",
}

export interface ISettlementFilterRow {
  name: string;
  nameSubLines: string[];
  propertyLabel?: string;
  // The unit's address of a "Privaat" settlement (its Type tooltip).
  unitAddress?: string;
  typeKey: TSettlementTypeKey;
  periodFrom: string;
  periodTo: string;
  progress?: TSettlementProgress;
}

const yearOf = (day: string): number => Number(day.slice(0, 4));

// Every year a settlement's period touches, newest first, as the cost
// list's year filter goes by a cost's period.
export const settlementYears = (rows: ISettlementFilterRow[]): number[] => {
  const years = new Set<number>();
  for (const row of rows) {
    if (!row.periodFrom || !row.periodTo) continue;
    for (
      let year = yearOf(row.periodFrom);
      year <= yearOf(row.periodTo);
      year += 1
    ) {
      years.add(year);
    }
  }
  return [...years].sort((a, b) => b - a);
};

// The search finds a settlement by its name, its tenants, its property or
// its unit's address; case and accents do not matter.
const normalized = (text: string): string =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export const settlementMatchesFilters = (params: {
  row: ISettlementFilterRow;
  query: string;
  type: ESettlementTypeFilter;
  year: string;
  status: ESettlementStatusFilter;
}): boolean => {
  const { row, query, type, year, status } = params;
  const needle = normalized(query.trim());
  if (needle) {
    const haystack = normalized(
      [row.name, ...row.nameSubLines, row.propertyLabel, row.unitAddress]
        .filter(Boolean)
        .join(" "),
    );
    if (!haystack.includes(needle)) return false;
  }
  if (type && row.typeKey !== type) return false;
  if (year) {
    const wanted = Number(year);
    if (
      !row.periodFrom ||
      !row.periodTo ||
      wanted < yearOf(row.periodFrom) ||
      wanted > yearOf(row.periodTo)
    ) {
      return false;
    }
  }
  if (status && row.progress !== status) return false;
  return true;
};
